import type { Dict } from "./types";

export const ar: Dict = {
  app: {
    name: "أكساراكو",
    tagline: "تعلّم أثناء اللعب",
  },
  common: {
    on: "مُفعّل",
    off: "متوقف",
    back: "رجوع",
    soon: "قريباً",
    loading: "لحظة من فضلك...",
  },
  nav: {
    parent: "الوالدان",
    home: "الرئيسية",
    writing: "الكتابة",
    games: "الألعاب",
    collection: "المجموعة",
    avatar: "الشخصية",
    groupLearn: "التعلّم",
    groupParent: "الوالدان",
    mainLabel: "التنقل الرئيسي",
    offlineReady: "جاهز دون اتصال",
    offlineActive: "وضع دون اتصال",
    mainProfile: "الملف الرئيسي",
  },
  profiles: {
    title: "من سيلعب؟",
    subtitle: "اختر طفلاً أو أضف ملفاً جديداً",
    add: "إضافة طفل",
    namePlaceholder: "اسم الطفل",
    language: "اللغة",
    start: "ابدأ",
    empty: "لا توجد ملفات بعد. أضف طفلاً أولاً.",
    errors: {
      emptyName: "الاسم مطلوب",
      nameTooLong: "الاسم طويل جداً",
      invalidLocale: "لغة غير معروفة",
    },
  },
  home: {
    greeting: "مرحباً يا {{name}}!",
    tracing: "الكتابة",
    games: "الألعاب",
    rewards: "المجموعة",
    avatar: "الشخصية",
    subtitle: "ماذا نتعلّم اليوم؟",
    streak: "{{count}} أيام",
    continue: {
      eyebrow: "أكمل التعلّم",
      cta: "أكمل",
      detail: "{{category}} · أتقنت {{current}} من {{total}}",
    },
    stats: {
      stars: "{{count}} نجمة",
      progress: "أتقنت {{current}} من {{total}} حرفاً",
    },
    hint: {
      tracing: "حروف وأرقام وأشكال",
      games: "٣ ألعاب ممتعة",
      rewards: "ملصقات وكؤوس وشخصيات",
      avatar: "خصّص صديقك",
    },
    progress: {
      title: "تقدّم الحروف",
      sub: "أتقنت {{current}} من {{total}} حرفاً",
      letters: "حروف {{current}}/{{total}}",
      numbers: "أرقام {{current}}/{{total}}",
      shapes: "أشكال {{current}}/{{total}}",
    },
    reward: {
      title: "الجائزة القادمة",
      count: "{{current}}/{{target}}",
    },
  },
  play: {
    title: "هيا نكتب",
    pick: "اختر حرفاً أو رقماً أو شكلاً",
    retry: "حاول مرة أخرى",
    next: "التالي",
    great: "أحسنت!",
    strokeProgress: "الخط {{current}} من {{total}}",
    offTrack: "اتبع الخط",
    listen: "استمع",
    canvasLabel: "منطقة كتابة {{glyph}}",
    objectHint: "{{glyph}} مثل {{object}}",
    color: "لوّن",
    letterTitle: "حرف {{glyph}}",
    digitTitle: "رقم {{glyph}}",
    shapeTitle: "الأشكال",
    digitSub: "الكتابة · من ١ إلى ١٠",
    shapeSub: "الكتابة · {{current}} من {{total}}",
    ratio: "{{current}} / {{total}}",
    pickShape: "اختر شكلاً آخر",
    tipLetter: "ابدأ من النقطة الزرقاء واتبع النقاط البرتقالية بهدوء.",
    tipDigit: "اتبع السهم من النقطة الأولى. خذ وقتك!",
    tipShape: "اتبع الخط بهدوء ولا تخرج عنه.",
    dragHint: "اسحب من النقطة الزرقاء عبر النقاط البرتقالية",
    progressTitle: "التقدم",
    reset: "أعد المحاولة",
    finish: "تم",
    nextDigit: "إلى الرقم {{glyph}}",
    nextGlyph: "إلى الحرف {{glyph}}",
    nextShape: "إلى الشكل {{name}}",
    retryGlyph: "أعد كتابة الحرف {{glyph}}",
    retryShape: "أعد رسم {{name}}",
    colorGlyph: "لوّن الحرف {{glyph}}",
    doneTitle: "أحسنت يا {{name}}!",
    doneSub: "لقد كتبت {{glyph}}. واصل التقدم!",
    chipStars: "{{count}} نجوم",
    chipLines: "{{count}} خطوط مكتملة",
    masteryLabel: "أتقنت {{current}} من {{total}}",
    linesCount: "{{count}} خطوط",
    pickerHint: "المس حرفاً لتبدأ الكتابة",
    unitUpper: "{{count}} حرفاً",
    unitLower: "{{count}} حرفاً صغيراً",
    unitDigit: "{{count}} رقماً",
    unitShape: "{{count}} شكلاً",
    recommendation: "مقترح لـ {{name}}",
    shape: {
      circle: "دائرة",
      oval: "بيضاوي",
      square: "مربع",
      rectangle: "مستطيل",
      triangle: "مثلث",
      star: "نجمة",
      heart: "قلب",
      line: "خط",
    },
  },
  games: {
    title: "الألعاب",
    matching: "المطابقة",
    balloon: "افقع البالون",
    coloring: "التلوين",
    pick: "اختر لعبتك المفضلة",
    matchingSub: "طابق الحروف الكبيرة والصغيرة",
    balloonSub: "افقع بالونات تحمل حروفاً",
    coloringSub: "لوّن الأرقام والأشكال",
    play: "ابدأ اللعب",
    footer: "كل لعبة مكتملة تمنحك نجمة لمجموعتك!",
    progressTitle: "تقدم اللعب",
    starsEarned: "{{count}} نجوم",
    played: "{{count}} مرة لعب",
    progressSub: "كل لعبة مكتملة تمنحك نجمة.",
    nextReward: "المكافأة التالية",
    nextRewardSub: "اجمع ٣ نجوم لفتح ملصق جديد.",
    modeCase: "كبير - صغير",
    modeObject: "حرف - صورة",
    casePrompt: "ابحث عن الحرف الصغير",
    objectPrompt: "ما هذا الحرف؟",
    balloonPrompt: "افقع البالون: {{letter}}",
    repeat: "أعد",
    correct: "صحيح!",
    wrong: "حاول مرة أخرى",
    playAgain: "العب مرة أخرى",
    score: "{{correct}} من {{total}} صحيح",
    colorHint: "اختر لوناً ثم المس الحرف",
    stickers: "الملصقات",
    clear: "مسح",
    finish: "إنهاء",
    finished: "عمل رائع!",
    paint: "لوّن",
    painted: "{{painted}} من {{total}} أجزاء ملوّنة",
  },
  preview: {
    title: "معاينة المحتوى",
    hint: "تحقق من شكل كل حرف ورقم وشكل.",
  },
  rewards: {
    title: "مجموعة المكافآت",
    pick: "ملصقات وكؤوس وشخصيات",
    summary: "فتحت {{unlocked}} من {{total}} مكافأة",
    footer: "أكمل الأنشطة لفتح مكافآت جديدة.",
    kind: {
      sticker: "ملصقات",
      trophy: "كؤوس",
      character: "شخصيات",
    },
    unlocked: "حصلت على مكافأة جديدة!",
    yeay: "رائع!",
    locked: "مقفل",
    done: "تم",
    requirement: {
      itemsAttempted: "جرّب {{count}} أنشطة",
      itemsMastered: "أتقن {{count}} حرفاً أو رقماً",
      starsEarned: "اجمع {{count}} نجوم",
      totalAttempts: "العب {{count}} مرات",
      kindMastered: "أتقن {{count}} في فئة واحدة",
    },
  },
  avatar: {
    title: "شخصيتي",
    pick: "خصّص صديقك",
    footer: "افتح أجزاء جديدة بجمع المكافآت.",
    slot: {
      color: "اللون",
      ears: "الأذنان",
      eyes: "العينان",
      accessory: "الإكسسوار",
    },
  },
  categories: {
    upper: "حروف كبيرة",
    lower: "حروف صغيرة",
    digits: "أرقام",
    shapes: "أشكال",
  },
  mastery: {
    new: "جديد",
    learning: "قيد التعلّم",
    familiar: "يتحسّن",
    mastered: "أتقن",
  },
  parent: {
    title: "منطقة الوالدين",
    subtitle: "تابع التقدّم وأدر التطبيق",
    gateTitle: "للوالدين فقط",
    gate: {
      question: "كم يساوي {{a}} + {{b}}؟",
      placeholder: "الإجابة",
      submit: "دخول",
      wrong: "الإجابة غير صحيحة",
      cancel: "إلغاء",
    },
    progressFor: "تقدّم {{name}}",
    progressQuick: "أتقن {{mastered}} • جرّب {{attempted}} • ⭐ {{stars}}",
    report: "تقرير التقدّم",
    navReport: "التقرير",
    summary: "الملخّص",
    statMastered: "أُتقن",
    statAttempted: "جُرِّب",
    statStars: "النجوم",
    statAttempts: "إجمالي المحاولات",
    levels: "مستويات الإتقان",
    byCategory: "حسب الفئة",
    needsPractice: "يحتاج تدريبًا",
    noWeak: "كل ما جرّبه أصبح متقنًا. أحسنت!",
    practiceDetail: "الدقة {{score}}% • {{attempts}} محاولة",
    tracingQuality: "جودة الكتابة",
    noTracing: "لا يوجد تدريب على الكتابة بعد.",
    avgAccuracy: "متوسط الدقة",
    traces: "عدد التدريبات",
    neverPlayed: "لا يوجد نشاط بعد.",
    lastPlayed: "آخر لعب: {{date}}",
    screenTime: "حد الوقت",
    sessionLimit: "حد الجلسة",
    breakReminder: "تذكير الاستراحة",
    breakOff: "معطّل",
    minutes: "{{minutes}} دقيقة",
    sessionRemaining: "الوقت المتبقي في الجلسة: {{time}}",
    settings: "الإعدادات",
    language: "اللغة",
    haptics: "الاهتزاز",
    audio: "الصوت",
    reduceMotion: "تقليل الحركة",
    switchProfile: "تغيير الطفل",
    preview: "معاينة المحتوى",
    manageChildren: "إدارة الأطفال",
    activeChild: "نشط",
    switchTo: "اختيار",
    delete: "حذف",
    deleteConfirm: "تأكيد الحذف؟",
    deleteHint: "حذف الطفل يحذف أيضًا تقدّمه ومجموعته.",
    lastChildHint: "يجب أن يبقى طفل واحد على الأقل.",
    childLanguage: "لغة {{name}}",
    cancel: "إلغاء",
  },
  session: {
    loading: "لحظة من فضلك…",
    expiredTitle: "وقت الاستراحة",
    expiredHint: "انتهت جلسة التعلّم اليوم. اطلب من أحد الوالدين فتحها مجددًا.",
    parentUnlock: "الوالدين",
    breakReminder: "تعلّمت {{minutes}} دقيقة. لنسترح قليلًا!",
    breakDone: "استرحت",
  },
  settings: {
    errors: {
      invalidLocale: "لغة غير صالحة",
      invalidSessionLimit: "حد الجلسة غير صالح",
      invalidBreakReminder: "تذكير الاستراحة غير صالح",
    },
  },
  error: {
    storage: "تعذّر حفظ البيانات. حاول مرة أخرى.",
    retry: "حاول مرة أخرى",
    reset: "إعادة تعيين البيانات",
    resetHint: "يحذف جميع الملفات والتقدّم على هذا الجهاز.",
    crash: "عفوًا، حدث خطأ ما. لنجرّب مرة أخرى.",
    crashRetry: "حاول مرة أخرى",
  },
  landing: {
    nav: {
      install: "ثبّت التطبيق",
      skip: "تخطٍّ إلى المحتوى",
    },
    hero: {
      tagline: "تعلّم أثناء اللعب",
      subtitle: "تطبيق تعليمي تفاعلي للصغار من 3 سنوات. كتابة ولعب وتعلّم — دون إنترنت ودون إعلانات.",
      ctaInstall: "ثبّت الآن",
      ctaHow: "شاهد كيف يعمل",
    },
    features: {
      title: "ماذا يوجد في أكساراكو؟",
      writing: { title: "الكتابة", desc: "تتبّع الحروف والأرقام والأشكال بإرشاد خطوة بخطوة." },
      games: { title: "الألعاب", desc: "طابق وافقع البالون ولوّن أثناء التعلّم." },
      rewards: { title: "المكافآت", desc: "اجمع الملصقات والكؤوس والشخصيات مع كل تدريب." },
      parent: { title: "لوحة الوالدين", desc: "تابع التقدّم وحدّد وقت الاستخدام وأدر ملفات الأطفال." },
    },
    how: {
      title: "كيف تبدأ",
      step1: { title: "التثبيت", desc: "أضفه إلى الشاشة الرئيسية" },
      step2: { title: "اختر الطفل", desc: "أنشئ ملفًا لصغيرك" },
      step3: { title: "ابدأ التعلّم", desc: "اختر حرفًا أو رقمًا أو لعبة" },
    },
    trust: {
      title: "لماذا أكساراكو؟",
      offline: "يعمل دون إنترنت",
      noAds: "بدون إعلانات أو مقاطعات",
      private: "البيانات تبقى على جهازك",
      multiChild: "ملفات لكل طفل",
    },
    languages: {
      title: "ثلاث لغات",
      id: "Bahasa Indonesia",
      en: "English",
      ar: "العربية (RTL)",
    },
    footer: {
      cta: "ابدأ الآن",
      madeBy: "صُنع بـ ❤️ بواسطة فريق Rohmad للذكاء الاصطناعي",
    },
    install: {
      instructions: "كيفية التثبيت",
      ios: "اضغط زر المشاركة، ثم اختر \"إضافة إلى الشاشة الرئيسية\".",
      android: "اضغط القائمة، ثم اختر \"إضافة إلى الشاشة الرئيسية\".",
      desktop: "انقر أيقونة التثبيت في شريط العنوان، أو استخدم قائمة المتصفح.",
      openApp: "افتح التطبيق",
    },
  },
};
